<template>
    <div>
        <Header />
        <div style="height: 3.4rem"></div>
        <router-view />
        <Footer />
    </div>
</template>

<script>
import Header from './header.vue';
import Footer from './footer.vue';

export default {
    name: 'Layout',
    components: { Header, Footer }
}
</script>

<style lang="less" scoped>

</style>